// extracted by mini-css-extract-plugin
export default {"shisha":"Shisha_shisha__-3uR9","imgWrapper":"Shisha_imgWrapper__shOq1"};